export function obterListaCteCargaTpMed() {
  return (
    [
      { label: 'Rolos', value: 'ROLOS' },
      { label: 'Bombonas', value: 'BOMBONAS' },
      { label: 'Caixas', value: 'CAIXAS' },
      { label: 'Containers', value: 'CONTAINERS' },
      { label: 'Cubagem da NF-e', value: 'CUBAGEMNFE' },
      { label: 'Cubagem Aferida pelo Transportador', value: 'CUBAGEMTRANSPORTADOR' },
      { label: 'Latas', value: 'LATAS' },
      { label: 'Litragem', value: 'LITRAGEM' },
      { label: 'Litragem Milhão de BTU', value: 'MBTU' },
      { label: 'Paletes', value: 'PALETES' },
      { label: 'Peso Base do Cálculo do Frete', value: 'PESOBASEFRETE' },
      { label: 'Peso Bruto da NF-e', value: 'PESOBRUTONFE' },
      { label: 'Peso Bruto Aferido pelo Transportador', value: 'PESOBRUTOTRANSPORTADOR' },
      { label: 'Peso Cubado', value: ' PESOCUBADO' },
      { label: 'Peso para uso Operacional', value: 'PESOOPERACIONAL' },
      { label: 'Sacas', value: 'SACAS' },
      { label: 'Outros', value: 'OUTROS' },
    ]
  );
}
